/* eslint-disable */
import "../assets/styles/Cards.css";

import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";

import "swiper/css/navigation";
// import required modules
import { Navigation } from "swiper";
import { useEffect, useState } from "react";
import Photo from "../assets/images/Players/Neeraj.jpg";
import { CoachesData } from "../assets/Data/CoachesData";
import { getCoachHome } from "../api/AuthenticationServices";
export default function Cards() {
  const [records, setRecords] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);
  async function fetchData() {
    try {
      const res = await getCoachHome();
      if (res.data.status === "success") {
        setRecords(res.data.data);
      }
    } catch (e) {
      console.log("Error " + e);
    }
  }
  return (
    <div className=".cardshtml">
      {records.length > 0 && (
        <div className="cardsbody">
          <h1>COACHES</h1>
          <Swiper
            navigation={true}
            modules={[Navigation]}
            className="mySwiper"
            breakpoints={{
              // when window width is >= 640px
              640: {
                width: 640,
                slidesPerView: 1,
              },
              // when window width is >= 768px
              768: {
                width: 768,
                slidesPerView: 2,
              },
              1024: {
                width: 1024,
                slidesPerView: 3,
              },
            }}
          >
            {records.map((item, index) => {
              return (
                <SwiperSlide className="full" key={item.id}>
                  <div className="swiper-slide tranding-slide">
                    <div className="tranding-slide-img">
                      <img
                        src={item.imgLink}
                        style={{ width: "300px", height: "350px" }}
                        alt="Tranding"
                      />
                    </div>
                    <div className="tranding-slide-content">
                      <div className="tranding-slide-content-bottom">
                        <h2 className="food-name">{item.name}</h2>
                        <h3 className="food-rating">
                          <span>{item.description}</span>
                        </h3>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      )}
    </div>
  );
}
